import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Container,
  Spinner,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Alert,
  Row,
  Col,
  Badge,
} from 'reactstrap';
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import {
  createQuotation,
  updateQuotation,
} from '../../redux/actions/quotation';
import { getClients } from '../../redux/actions/client';
import { useLocation, useNavigate  } from 'react-router-dom'
import Loading from '../../components/Loading/Loading';

function CreateQuotation() {
  const dispatch = useDispatch();
  const currentLang = useSelector((state) => state.lang.lang);
  const response = useSelector((state) => state.quotation.create);
  const responseUpdate = useSelector((state) => state.quotation.update);
  const clientState = useSelector((state) => state.client.get);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [pdf, setPdf] = useState();
  const [email, setEmail] = useState('');
  const [contact, setContact] = useState('');
  const [sirs, setSirs] = useState('');
  const [rut, setRut] = useState('');
  const [phone, setPhone] = useState('');
  const [obs, setObs] = useState('');
  const [price, setPrice] = useState('');
  const [iva, setIva] = useState('');
  const [comission, setComission] = useState('');
  const [name, setName] = useState('');
  const [version, setVersion] = useState(1);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [update, setupdate] = useState(false);

  // Estados para la búsqueda de clientes
  const [clientSearch, setClientSearch] = useState('');
  const [clients, setClients] = useState([]);
  const [showClientSuggestions, setShowClientSuggestions] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [useCompanyData, setUseCompanyData] = useState(false);

  useEffect(() => {
    if (response && loading && update) {
      if (response.message === 'Quotation created') {
        setAlertTitle(response.message);
        window.open(response.data);

        setLoading(false);
        setShowAlert(true);
        goToQuotationList();
      }
    }
    if (responseUpdate && loading && update) {
      if (responseUpdate.message === 'Quotation updated') {
        setAlertTitle(responseUpdate.message);
        window.open(responseUpdate.data);

        setLoading(false);
        setShowAlert(true);
        goToQuotationList();
      }
    }
  }, [response, responseUpdate]);

  const goToQuotationList = () => {
    navigate('/quotationlist');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'BGL - Crear Cotizacion';
  }, []);

  useEffect(() => {
    if (!location.state?.data) {
      return;
    } else if (update === false) {
      let data = location.state.data;
      setPrice(data.price);
      setIva(data.iva);
      setComission(data.comission);
      if (data.pdf) {
        setData(data.numerointerno);
        setEmail(data.email);
        setContact(data.contact);
        setSirs(data.sirs);
        setRut(data.rut);
        setPhone(data.phone);
        setObs(data.obs);
        setPrice(data.price);
        setIva(data.iva);
        setComission(data.comission);
        setPdf(data.pdf);
        setVersion(data.version);
      } else {
        setData(data.numerointerno);
      }
      setLoading(false);
      setupdate(true);
    }
  });

  // Funciones para la búsqueda de clientes
  const handleClientSearch = (e) => {
    const value = e.target.value;
    setClientSearch(value);
    setShowClientSuggestions(true);

    if (value.length > 0) {
      dispatch(getClients(value));
    } else {
      setClients([]);
    }
  };

  const handleClientSelect = (client) => {
    setSelectedClient(client);
    setClientSearch('');
    setUseCompanyData(false); // Reset company data selection

    // Set default data (persona natural)
    setSirs(client.data.firstName + ' ' + client.data.lastName);
    setRut(client.data.rut || '');
    setEmail(client.data.email || '');
    setPhone(client.data.phone || '');
    setContact(''); // Reset company field
    setShowClientSuggestions(false);
  };

  const handleRemoveClient = () => {
    setSelectedClient(null);
    setUseCompanyData(false);
    setSirs('');
    setRut('');
    setEmail('');
    setPhone('');
    setContact('');
  };

  const handleCompanyDataToggle = () => {
    if (!selectedClient?.data) return;

    setUseCompanyData(!useCompanyData);

    if (!useCompanyData) {
      // Switch to company data
      const companyInfo = selectedClient.data.companyInfo;
      if (companyInfo) {
        setSirs(companyInfo.name || '');
        setRut(companyInfo.rut || '');
        setContact(companyInfo.name || '');
        // Keep email and phone from personal data
      }
    } else {
      // Switch to personal data
      setSirs(
        selectedClient.data.firstName + ' ' + selectedClient.data.lastName,
      );
      setRut(selectedClient.data.rut || '');
      setContact('');
    }
  };

  const handleCreateClient = () => {
    navigate('/client-form', { state: { returnTo: '/item-quotation' } });
  };

  // Effect para manejar los datos de clientes
  useEffect(() => {
    if (clientState?.data) {
      setClients(clientState.data);
    }
  }, [clientState]);

  const onDismiss = () => setShowAlert(false);

  const onFormSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setName(data + ' ' + sirs);
    if (pdf) {
      dispatch(
        updateQuotation(
          data,
          sirs,
          rut,
          contact,
          email,
          phone,
          obs,
          price,
          iva,
          comission,
          name,
          pdf,
          version,
        ),
      );
    } else {
      dispatch(
        createQuotation(
          data,
          sirs,
          rut,
          contact,
          email,
          phone,
          obs,
          price,
          iva,
          comission,
          name,
          version,
        ),
      );
    }
  };

  function numberWithDot(x) {
    let n = x.split('.').join('');
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  const onChangeValue = (value) => {
    let n = numberWithDot(value);
    setPrice(n);
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Container>
        <Alert isOpen={showAlert} toggle={onDismiss}>
          {alertTitle} - {alertMessage}
        </Alert>
      </Container>
      <h3 style={{ textAlign: 'center' }}>
        NUMERO INTERNO: {location.state?.data?.numerointerno}
      </h3>
      <Container className="p-3 container-border">
        <Form onSubmit={(e) => onFormSubmit(e)}>
          <Row>
            <Col lg="4"></Col>
            <Col sm="12" lg="12">
              <FormGroup>
                <Label for="clientSearch">Cliente</Label>
                <section className="position-relative">
                  {selectedClient?.data ? (
                    <section>
                      <section className="d-flex align-items-center mb-2">
                        <Badge color="primary" className="mr-2 p-2">
                          {useCompanyData && selectedClient.data.isCompany
                            ? selectedClient.data.companyInfo?.name
                            : selectedClient.data.firstName +
                              ' ' +
                              selectedClient.data.lastName}{' '}
                          -{' '}
                          {useCompanyData && selectedClient.data.isCompany
                            ? selectedClient.data.companyInfo?.rut
                            : selectedClient.data.rut}
                        </Badge>
                        <Button
                          color="link"
                          size="sm"
                          className="p-0"
                          onClick={handleRemoveClient}
                        >
                          <i className="fa fa-times"></i>
                        </Button>
                      </section>
                      {selectedClient.data.isCompany && (
                        <section className="mb-2">
                          <Label check className="d-flex align-items-center">
                            <Input
                              type="checkbox"
                              checked={useCompanyData}
                              onChange={handleCompanyDataToggle}
                              className="mr-2"
                            />
                            Desea cotización por empresa
                          </Label>
                        </section>
                      )}
                    </section>
                  ) : (
                    <Input
                      id="clientSearch"
                      type="text"
                      placeholder="Buscar cliente por nombre, apellido, RUT, teléfono o correo electrónico"
                      value={clientSearch}
                      onChange={handleClientSearch}
                      onBlur={() =>
                        setTimeout(() => setShowClientSuggestions(false), 200)
                      }
                      disabled={loading}
                    />
                  )}
                  {showClientSuggestions && (
                    <section
                      className="position-absolute w-100 bg-white border rounded-bottom"
                      style={{ zIndex: 1000 }}
                    >
                      {clients.length > 0 ? (
                        clients.map((client) => (
                          <section
                            key={client.id}
                            className="px-3 py-2 cursor-pointer hover-bg-light"
                            onClick={() => handleClientSelect(client)}
                          >
                            <span className="font-weight-bold">
                              {client.data.firstName} {client.data.lastName}
                            </span>
                            {client.data.isCompany && (
                              <span className="text-info ml-2">
                                <i className="fa fa-building mr-1"></i>
                                Empresa: {client.data.companyInfo?.name}
                              </span>
                            )}
                            <br />
                            <span className="text-muted">
                              {client.data.rut} | {client.data.phone}
                            </span>
                          </section>
                        ))
                      ) : (
                        <section className="px-3 py-2">
                          <p className="mb-0">No se encontraron clientes</p>
                          <Button
                            color="primary"
                            size="sm"
                            className="mt-2"
                            onClick={handleCreateClient}
                          >
                            <i className="fa fa-plus mr-2"></i>
                            Crear nuevo cliente
                          </Button>
                        </section>
                      )}
                    </section>
                  )}
                </section>
              </FormGroup>
              <FormGroup>
                <Label for="sirs">Señores</Label>
                <Input
                  type="text"
                  placeholder="Señores..."
                  disabled={loading}
                  onChange={(e) => setSirs(e.target?.value)}
                  value={sirs}
                />
              </FormGroup>
              <FormGroup>
                <Label for="rut">RUT</Label>
                <Input
                  type="text"
                  placeholder="RUT..."
                  disabled={loading}
                  onChange={(e) => setRut(e.target?.value)}
                  value={rut}
                />
              </FormGroup>
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  type="text"
                  placeholder="Email..."
                  disabled={loading}
                  onChange={(e) => setEmail(e.target?.value)}
                  value={email}
                />
              </FormGroup>
              <FormGroup>
                <Label for="contact">Empresa</Label>
                <Input
                  type="text"
                  placeholder="EMPRESA..."
                  disabled={loading}
                  onChange={(e) => setContact(e.target?.value)}
                  value={contact}
                />
              </FormGroup>
              <FormGroup>
                <Label for="phone">Telefono</Label>
                <Input
                  type="text"
                  placeholder="Telefono..."
                  disabled={loading}
                  onChange={(e) => setPhone(e.target?.value)}
                  value={phone}
                />
              </FormGroup>
              <FormGroup>
                <Label for="price">Valor</Label>
                <Input
                  type="text"
                  placeholder="Valor..."
                  disabled={loading}
                  value={price}
                  onChange={(e) => setPrice(numberWithDot(e.target?.value))}
                />
              </FormGroup>
              <FormGroup>
                <Label for="comission">Comisión %</Label>
                <Input
                  type="text"
                  placeholder="Comision %..."
                  disabled={loading}
                  value={comission}
                  onChange={(e) => setComission(e.target?.value)}
                />
              </FormGroup>
              <FormGroup>
                <Label for="iva">IVA</Label>
                <Input
                  type="text"
                  placeholder="IVA..."
                  disabled={loading}
                  value={iva}
                  onChange={(e) => setIva(e.target?.value)}
                />
              </FormGroup>
            </Col>
            <Col lg="4"></Col>
          </Row>

          <FormGroup>
            <Label for="name">Observaciones</Label>
            <Input
              type="textarea"
              placeholder="Observaciones..."
              disabled={loading}
              onChange={(e) => setObs(e.target?.value)}
              value={obs}
            />
          </FormGroup>
          <Button disabled={loading}>Guardar</Button>
        </Form>
      </Container>
    </>
  );
}
export default CreateQuotation;
